<template>
  <div class="fund-project-list-container">
    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchResets"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        id="avue_manage"
        :header-cell-class-name="headerClassName"
      >
        <template slot="createTime" slot-scope="{ row }">
          <div >
            {{ row.changeNumber>0?`(变${row.changeNumber})`:'' }}{{ row.createTime?moment().format("YYYY-MM"):'' }}
          </div>
        </template>

        <template slot-scope="scope" slot="menu">
          <div style="text-align: center">
            <el-button
              type="success"
              plain
              size="small"
              icon="el-icon-arrow-right"
              @click.stop="handleDetails(scope.row.id)"
              >详情
            </el-button>
          </div>
        </template>
      </avue-crud>
    </div>
  </div>
</template>
  <script>
import { investmentReportListConfig } from "../config.js";
import { getFdbasicinfo } from "@/api/fund/fundProject";

import { mapGetters } from "vuex";
import util from "@/mixins/util";
export default {
  name: "FundProjectListComponent",
  mixins: [util],
  data() {
    return {
      tableData: [],
      dialogType: 1,
      formData: {},
      dialogShow: false,
      selectionList: [],
      tableConfig: investmentReportListConfig(this.getMoney),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
    };
  },
  components: {},
  watch: {
    // isEdit: {
    //   handler(newValue, oldValue) {
    //     if (newValue == true) {
    //       this.tableConfig.selection = true;
    //       this.queryTableData();
    //     }
    //   },
    //   immediate: true,
    // },
    fundId: {
      handler(newValue, oldValue) {
        if (newValue > -1) {
          this.queryTableData();
        }
      },
      immediate: true,
    },
  },
  props: {
    fundsName: {
      type: String,
      required: true,
    },
    fundId: {
      type: String,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    bizType: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  mounted() {},
  methods: {
    headerClassName(tab){
       
      return 'avue_bgc';
    },


    handleDetails(id) {
      // 跳转3个不同的数据填报
      window.open(
        window.location.origin +
          `/#/fundManageClient/${this.fundsName}/detail/${id}?audit=true`
      );
    },
    selectionChange(data) {
      this.selectionList = data;
    },

    searchChange(query, done) {
      this.searchForm = query;
      this.page.currentPage = 1;
      this.queryTableData();
      done();
    },

    async queryTableData() {
      if (!this.fundId) {
        return;
      }
      let params = {
        fundId: this.fundId,
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        bizType: this.bizType,
        // auditState: 2,
        noAuth:1

      };
      let res = {};

      res = await getFdbasicinfo(params);

      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },
  },
};
</script>
  <style lang="scss" scoped>
.fund-project-list-container {
  .project-tip {
    color: rgb(255, 153, 0);
    font-size: 12px;
    padding-left: 170px;
  }
  .project-name {
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    // background-color: rgb(245, 245, 245);
    color: #333;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px 20px !important;
  }
  /deep/ .avue-form__menu--center {
    display: none;
  }
  // /deep/ .avue-form__menu--center {
  //   display: none;
  // }
  // /deep/ .avue-crud__menu{
  //   display: none;
  // }
  // /deep/.el-table__fixed-footer-wrapper {
  //   bottom: -51px;
  // }
  // /deep/.el-table__fixed,
  // .el-table__fixed-right {
  //   height: calc(100% - 51px) !important;
  // }
}
/deep/ .el-table .cell,
/deep/ .el-table th > .cell {
  padding-left: 0px;
  padding-right: 0px;
}
/deep/ .el-table .cell {
  font-size: 14px;
}
/deep/ .el-table__fixed-footer-wrapper {
  display: none !important;
}
#avue_manage .header_bgc {
    background-color: red;
  
}

/deep/.el-table td {
  padding:12px 0 !important
}
/deep/ .el-table {
    border-color: #e0eeff;
}
/deep/.avue_bgc{
  background: #F6FAFF !important;
  font-weight: 400 !important;
}
/deep/.avue-crud {
    width:100%
  }

</style>